import { render, staticRenderFns } from "./antibiotics.vue?vue&type=template&id=4d65831f&scoped=true&"
import script from "./antibiotics.vue?vue&type=script&lang=js&"
export * from "./antibiotics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65831f",
  null
  
)

export default component.exports